export default __webpack_public_path__ + "images/a0d1334cfa55dc87948ae4cc4c336957.svg";